import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=6cde1cdc"
import script from "./EditArticle.vue?vue&type=script&lang=ts"
export * from "./EditArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports